import { Autocomplete, Box, Button, Divider, Grid, IconButton, Modal, Stack, TextField, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next';
import { Field } from '../../miProfile/Field'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useForm } from '../../../../hooks';
import { useDispatch, useSelector } from 'react-redux';
import { unSelectEventRegistered } from '../../../../store/eventRegistered/eventRegisteredSlice';
import { editEventRegistered } from '../../../helpers/eventRegister';
import { NumberInput } from '../../NumberInput';
import { style } from '../../../../helpers/editStyle';

export const EditEventRegister = ({ setHidden, setReloadData }) => {

    const { t } = useTranslation('global');
    const { dataToAction } = useSelector(state => state.eventRegistered)

    const dispatch = useDispatch();
    const [formValues, handleInputChange, reset] = useForm({ ...dataToAction, confirmsAttendance: dataToAction.confirmsAttendance === 'Confirmada' ? 'Si' : 'No' });

    const { principalAssistant, companions, comments, confirmsAttendance } = formValues;


    const handleCancel = () => {
        reset()
        dispatch(unSelectEventRegistered())
        setHidden(false)
    }
    const onSubmit = (e) => {
        e.preventDefault();
        const assistanceBBDD = confirmsAttendance === 'Si' ? 'Confirmada' : 'No';
        if (confirmsAttendance === 'Si') {
            editEventRegistered({...formValues, confirmsAttendance: assistanceBBDD }, t('addevent.succesEditMsg'), t('addevent.errorMsg'), t('error.errorNameDup'))
        } else {
            editEventRegistered({...formValues, confirmsAttendance: assistanceBBDD, principalAssistant: '', companions:0, comments: '' }, t('addevent.succesEditMsg'), t('addevent.errorMsg'), t('error.errorNameDup'))
        }
        setReloadData(prevState => !prevState)
        setHidden(false)
    }

    return (
        <Modal
            open={true}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={{ zIndex: 9999 }}
        >
            <Box sx={style}>
                <Stack direction='row' justifyContent='space-between' alignItems='baseline' sx={{ height: '50px' }}>
                    <Typography color='primary' marginBottom='10px' variant='h5' fontWeight={700}>{t('addevent.editAssistanceTitle')}</Typography>
                    <IconButton color='primary' onClick={handleCancel}>
                        <CloseRoundedIcon />
                    </IconButton>
                </Stack>
                <form onSubmit={onSubmit} style={{ padding: '10px 5px', display: 'flex', flexDirection: 'column', justifyContent: 'space-around' }}>
                    <Stack sx={{ height: 'calc(70vh - 200px)', overflowY: 'auto', paddingBottom: '10px', paddingRight: '20px' }}>

                        <Grid container direction='row' width='100%' >
                            <Grid item xs={12} padding='0 5px'>
                                <Typography variant='overline' color='secondary'>{t('addevent.addInvestor')}</Typography>
                                <Autocomplete
                                    disablePortal
                                    options={["Si", "NO"]}
                                    size='small'
                                    renderInput={(params) => <TextField  {...params} variant='outlined' name='confirmsAttendance' />}
                                    value={confirmsAttendance}
                                    onSelect={handleInputChange}
                                    fullWidth
                                    required
                                />
                            </Grid>
                        </Grid>

                        <Grid container direction='row' width='100%' >
                            <Grid item xs={12} padding='0 5px'>
                                <Field translation='addevent' name={principalAssistant} title='principalAssistant' handleInputChange={handleInputChange} required={true} isDisabled={confirmsAttendance !== 'Si'} />
                            </Grid>
                        </Grid>
                        <Grid container direction='row' width='100%' >
                            <Grid item xs={12} padding='0 5px'>
                                <NumberInput translation='addevent' name={companions} title='companions' handleInputChange={handleInputChange} required={true} isDisabled={confirmsAttendance !== 'Si'}/> 
                            </Grid>
                        </Grid>

                        <Grid container direction='row' width='100%'>
                            <Grid item xs={12} padding='0 5px'>
                                <Field translation='addevent' name={comments} title='comments' handleInputChange={handleInputChange} required={true} isDisabled={confirmsAttendance !== 'Si'}/> 
                            </Grid>
                        </Grid>

                    </Stack>

                    <Stack sx={{ heigth: '80px' }}>
                        <Divider sx={{ margin: '30px 0px 15px 0px' }} />

                        <Grid container direction='row' width='100%' >
                            <Grid item xs={12} md={6} padding='0 5px'>
                                <Button fullWidth onClick={handleCancel} variant="text">{t("createPassword.cancelButton")}</Button>
                            </Grid>
                            <Grid item xs={12} md={6} padding='0 5px'>
                                <Button fullWidth type='submit' variant="contained">{t("createPassword.principalButton")}</Button>
                            </Grid>
                        </Grid>
                    </Stack>
                </form>

            </Box>
        </Modal>
    )
}